import { gql } from '@apollo/client';

export const TRIGGER_ENERGY_CREDIT_SUBMISSION_EXPORT = gql`
  mutation TriggerEnergyCreditSubmissionExport {
    TriggerEnergyCreditSubmissionExport {
      Success
    }
  }
`;

export const TRIGGER_HEAT_PUMP_INVOICE_SYNC = gql`
  mutation TriggerHeatPumpInvoiceSync {
    TriggerHeatPumpInvoiceSync {
      Success
    }
  }
`;

export const TRIGGER_ENERGY_EFFICIENCY_BACKFILL = gql`
  mutation TriggerEnergyEfficiencyBackfill {
    TriggerEnergyEfficiencyBackfill {
      Success
    }
  }
`;

export const GET_EXPORTABLE_SUBMISSIONS = gql`
  query GetExportableSubmissions {
    GetExportableSubmissions {
      Count
    }
  }
`;

export const DELETE_DATABASE_INSPECTION = gql`
  mutation DeleteDatabaseInspection($payload: String!) {
    DeleteDatabaseInspection(Payload: $payload) {
      Success
      Message
      UpdatedData
    }
  }
`;
